import { onMounted, onUnmounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { TenantService, UserService, connectionService } from 'app-core'
import { useAppStore } from '@/stores/useAppStore'
import { useToast } from '@/composables/useToast'
import i18n from '@/i18n'

const t = i18n.global.t
const { toast } = useToast()

export function useConnectionMonitor() {
  const store = useAppStore()
  const router = useRouter()

  onMounted(() => {
    window.addEventListener('online', onDeviceOnline)
    window.addEventListener('offline', onDeviceOffline)
  })

  onUnmounted(() => {
    window.removeEventListener('online', onDeviceOnline);
    window.removeEventListener('offline', onDeviceOffline);

    connectionService.stopPeriodicConnectionCheck()
  })

  watch(() => store.isOnline, async (val, oldVal) => {
    if (val && !oldVal) {
      toast(t('connection.internet_online_message_again'), 'success');

      const tenantToken = await TenantService.getToken()
      const userToken = await UserService.getToken()

      if(!tenantToken) {
        router.push({ name: 'tenantLogin' })
      } else if(!userToken) {
        router.push({ name: 'userLogin' })
      }
    } else if (!val && oldVal) {
      toast(t('connection.internet_offline_message'), 'error', { duration: 10000 });
    }
  })

  function onDeviceOnline() {
    connectionService.onDeviceOnline()
  }

  function onDeviceOffline() {
    connectionService.onDeviceOffline()
  }
}
